import {
  ForeAftEnum,
  IOpenVesselDefinitionV1,
  LcgReferenceEnum,
  PortStarboardEnum,
  ValuesSourceEnum,
  ValuesSourceRowTierEnum,
  ovdV1ToStafConverter,
} from "open-vessel-definition";

import UoLcgReferenceEnum from "../../../../../../../app/enums/UoLcgReferenceEnum";
import VcgVerticalReferenceEnum from "../../../../../../../app/enums/VcgVerticalReferenceEnum";

export function createStafFile(
  json: IOpenVesselDefinitionV1,
  exportStafOptions: IExportStafOptions,
) {
  //Do conversion here and resolve with STAF file converted
  const stafFile = ovdV1ToStafConverter(json, {
    cgOptions: {
      lcgOptions: {
        reference:
          exportStafOptions.lcgRef === UoLcgReferenceEnum.AFT_PERPENDICULAR_DFWD
            ? LcgReferenceEnum.AFT_PERPENDICULAR
            : exportStafOptions.lcgRef ===
              UoLcgReferenceEnum.FWD_PERPENDICULAR_DAFT
            ? LcgReferenceEnum.FWD_PERPENDICULAR
            : LcgReferenceEnum.MIDSHIPS,

        orientationIncrease:
          exportStafOptions.lcgRef === UoLcgReferenceEnum.AFT_PERPENDICULAR_DFWD
            ? ForeAftEnum.FWD
            : exportStafOptions.lcgRef ===
              UoLcgReferenceEnum.FWD_PERPENDICULAR_DAFT
            ? ForeAftEnum.AFT
            : exportStafOptions.lcgRef === UoLcgReferenceEnum.MIDSHIPS_DFWD
            ? ForeAftEnum.FWD
            : ForeAftEnum.AFT,

        lpp: json.shipData?.lcgOptions?.lpp || 0,
        values: json.shipData?.lcgOptions.values || ValuesSourceEnum.ESTIMATED,
      },
      vcgOptions: {
        values:
          json.shipData?.vcgOptions.values === ValuesSourceEnum.ESTIMATED
            ? ValuesSourceRowTierEnum.ESTIMATED
            : ValuesSourceRowTierEnum.BY_STACK,

        heightFactor:
          exportStafOptions.vcgRef === VcgVerticalReferenceEnum.VCG_45_8_6
            ? 0.45
            : exportStafOptions.vcgRef === VcgVerticalReferenceEnum.VCG_50_8_6
            ? 0.5
            : 0,
      },
      tcgOptions: {
        values: json.shipData?.tcgOptions.values || ValuesSourceEnum.ESTIMATED,

        direction: exportStafOptions.tcgRef || PortStarboardEnum.STARBOARD,
      },
    },
    tier82is: exportStafOptions.tier82is || 82,
    removeBaysWithNonSizeSlots: exportStafOptions.removeBaysWithNonSizeSlots,
    removeCGs: exportStafOptions.addRemoveCgs === "remove",
    removeBelowTiers24AndHigher: exportStafOptions.remove24s ?? false,
  });

  return stafFile;
}

export interface IExportStafOptions extends Record<string, unknown> {
  tier82is?: number;
  lcgRef?: number;
  tcgRef?: number;
  vcgRef?: number;
  removeBaysWithNonSizeSlots?: boolean;
  addRemoveCgs: "none" | "remove" | "addArtificial";
  remove24s?: boolean;
}
